<template>
  <svg
    :width="width"
    viewBox="0 0 200 149"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M132.456 42.9479C103.903 24.6421 83.5406 22.1022 69.5262 36.7782C55.5118 51.4541 48.774 103.712 69.5146 121.796C90.2551 139.879 130.62 116.94 144.634 102.264C158.649 87.5879 170.618 63.1287 132.456 42.9479Z"
      :fill="getColor('0.1', primaryColor)"
    />
    <path
      d="M182.303 103.755L195.666 114.263H156.53V90.889H195.666L182.303 101.397L180.803 102.576L182.303 103.755Z"
      :fill="primaryLight"
      :stroke="textColor"
      stroke-width="3"
    />
    <path
      d="M16.8115 101.423L4.14872 90.889L43.4703 90.889L43.4703 114.263L4.14873 114.263L16.8115 103.729L18.1978 102.576L16.8115 101.423Z"
      :fill="primaryLight"
      :stroke="textColor"
      stroke-width="3"
    />
    <rect
      x="33.4524"
      y="81.47"
      width="136.645"
      height="26.1993"
      :fill="primaryLight"
      :stroke="textColor"
      stroke-width="3"
    />
    <path
      d="M137.301 92.5166L130.137 97.403L138.4 101.649L137.301 92.5166Z"
      :fill="getColor('0.7', primaryColor)"
    />
    <path
      d="M68.3042 68.5088L62.2894 68.6655L65.5123 74.2478L68.3042 68.5088Z"
      :fill="getColor('0.5', primaryColor)"
    />
    <path
      d="M70.953 45.6599L66.2129 49.3659L72.1254 51.9334L70.953 45.6599Z"
      :fill="getColor('0.5', primaryColor)"
    />
    <path
      d="M91.9533 113.853L87.9582 118.352L94.2363 119.813L91.9533 113.853Z"
      fill="white"
    />
    <path
      d="M35.8073 69.5489L27.3756 67.5235L29.78 76.4968L35.8073 69.5489Z"
      :fill="getColor('0.7', primaryColor)"
    />
    <rect
      x="41.8219"
      y="50.4883"
      width="2.29774"
      height="6.89321"
      transform="rotate(-76.8541 41.8219 50.4883)"
      :fill="getColor('1', primaryColor)"
    />
    <rect
      x="45.7755"
      y="53.7708"
      width="2.29773"
      height="6.8932"
      transform="rotate(-166.854 45.7755 53.7708)"
      :fill="getColor('1', primaryColor)"
    />
    <rect
      x="47.4573"
      y="25.6408"
      width="2.29774"
      height="6.89321"
      transform="rotate(-73.5281 47.4573 25.6408)"
      fill="white"
    />
    <rect
      x="51.2123"
      y="29.1466"
      width="2.29774"
      height="6.89321"
      transform="rotate(-163.528 51.2123 29.1466)"
      fill="white"
    />
    <rect
      x="146.575"
      y="44.9147"
      width="2.29774"
      height="6.89321"
      transform="rotate(-73.5281 146.575 44.9147)"
      fill="white"
    />
    <rect
      x="150.332"
      y="48.42"
      width="2.29774"
      height="6.89321"
      transform="rotate(-163.528 150.332 48.42)"
      fill="white"
    />
    <rect
      x="96.9468"
      y="4.60275"
      width="2.05333"
      height="6.16"
      transform="rotate(-73.5281 96.9468 4.60275)"
      :fill="getColor('1', primaryColor)"
    />
    <rect
      x="100.304"
      y="7.73524"
      width="2.05333"
      height="6.16"
      transform="rotate(-163.528 100.304 7.73524)"
      :fill="getColor('1', primaryColor)"
    />
    <circle
      cx="29.4701"
      cy="48.8678"
      r="2.29774"
      transform="rotate(-73.5281 29.4701 48.8678)"
      :fill="getColor('0.8', textColor)"
    />
    <circle
      cx="133.177"
      cy="21.335"
      r="2.29774"
      transform="rotate(-73.5281 133.177 21.335)"
      :fill="getColor('0.8', textColor)"
    />
    <circle
      cx="170.806"
      cy="50.7034"
      r="2.29774"
      transform="rotate(-73.5281 170.806 50.7034)"
      :fill="getColor('0.8', textColor)"
    />
    <circle
      cx="67.0983"
      cy="7.56862"
      r="2.29774"
      transform="rotate(-73.5281 67.0983 7.56862)"
      :fill="getColor('0.8', textColor)"
    />
    <circle
      cx="50.5786"
      cy="63.5521"
      r="2.29774"
      transform="rotate(-73.5281 50.5786 63.5521)"
      :fill="getColor('0.8', textColor)"
    />
    <path
      d="M156.159 88.4383L162.894 86.6651L161.063 93.3845L156.159 88.4383Z"
      :fill="getColor('0.7', primaryColor)"
    />
    <path
      d="M121.838 66.607L132.098 63.9057L129.308 74.1418L121.838 66.607Z"
      :fill="getColor('0.3', primaryColor)"
    />
    <path
      d="M95.757 73.0452L101.062 63.8569L106.367 73.0452L95.757 73.0452Z"
      :fill="getColor('0.7', primaryColor)"
    />
    <path
      d="M44.6474 103.657L42.2417 94.6788L51.2198 97.0845L44.6474 103.657Z"
      :fill="getColor('0.3', primaryColor)"
    />
    <path
      d="M57.9848 91.6724L63.2923 88.9397L63.0052 94.9025L57.9848 91.6724Z"
      fill="white"
    />
    <path
      d="M102.832 93.9031L106.084 95.7809L102.832 97.6587L102.832 93.9031Z"
      :fill="getColor('0.7', primaryColor)"
    />
    <path
      d="M144.255 70.8347L148.011 70.8347L146.133 74.0872L144.255 70.8347Z"
      :fill="getColor('0.7', primaryColor)"
    />
    <path
      d="M99.6794 118.062L102.335 115.406L103.307 119.034L99.6794 118.062Z"
      :fill="getColor('0.7', primaryColor)"
    />
    <path
      d="M135.76 7.82904L141.169 6.40505L139.698 11.801L135.76 7.82904Z"
      fill="white"
    />
    <path
      d="M186.136 73.2198L188.842 68.325L191.728 73.1157L186.136 73.2198Z"
      :fill="getColor('0.5', primaryColor)"
    />
    <rect
      x="78.0099"
      y="9.30246"
      width="4.58881"
      height="118.391"
      :fill="textColor"
    />
    <path
      d="M128.029 45.331L143.608 58.2793H107.961V30.0754H143.608L128.029 43.0238L126.641 44.1774L128.029 45.331Z"
      fill="white"
      :stroke="textColor"
      stroke-width="3"
    />
    <rect
      x="81.0989"
      y="17.8977"
      width="41.546"
      height="33.2862"
      fill="white"
      :stroke="textColor"
      stroke-width="3"
    />
    <path
      d="M114.72 19.3977H101.159L84.4343 49.6838H98.4062L114.72 19.3977Z"
      :fill="primaryColor"
    />
  </svg>
</template>

<script lang="ts">
import Vue from "vue"

export default Vue.extend({
  name: "ConfettiFlag",
  props: {
    width: { type: String, default: "200" },
  },
  data() {
    return {
      primaryColor: this.$vuetify.theme.themes.light.primary,
      primaryLight: this.$vuetify.theme.themes.light.primaryLight,
      textColor: this.$vuetify.theme.themes.light.textColor,
    }
  },
  methods: {
    getColor(alphaString = "1", color) {
      let r = parseInt(color.slice(1, 3), 16),
        g = parseInt(color.slice(3, 5), 16),
        b = parseInt(color.slice(5, 7), 16)

      return "rgba(" + r + ", " + g + ", " + b + ", " + alphaString + ")"
    },
  },
})
</script>

<style lang="scss" scoped></style>
